import { render, staticRenderFns } from "./RiderApproveViews.vue?vue&type=template&id=b52de49e&scoped=true"
import script from "./RiderApproveViews.vue?vue&type=script&lang=js"
export * from "./RiderApproveViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52de49e",
  null
  
)

export default component.exports